import { Divider, Grid } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import theme from "Theme/AppTheme";
import { useStore } from "utils/useStore";
import SignalsPageStore from "../Store/SignalsPageStore";
import { SidebarDashboards } from "./SidebarDashboards";

// The items below the divider in the SignalsSidebar. These are specific to Signals and not in Reporting
const SignalsNavItems = observer(() => {
    const signalsPageStore = useStore(SignalsPageStore);

    return (
        <>
            <Grid container sx={{ paddingX: 2 }}>
                <SidebarDashboards
                    isLoading={signalsPageStore.getTaskLoading(
                        "LoadDashboards",
                    )}
                    dashboards={signalsPageStore.standardDashboards}
                />
            </Grid>
            {signalsPageStore &&
                signalsPageStore.favoritedDashboards.length > 0 && (
                    <>
                        <SectionHeader divider title="FAVORITES" />
                        <Grid container sx={{ paddingX: 2 }}>
                            <SidebarDashboards
                                isLoading={signalsPageStore.getTaskLoading(
                                    "LoadDashboards",
                                )}
                                dashboards={
                                    signalsPageStore.favoritedDashboards
                                }
                            />
                        </Grid>
                    </>
                )}
            <SectionHeader divider title="MY DASHBOARDS" />
            <Grid container sx={{ paddingX: 2 }}>
                <SidebarDashboards
                    isLoading={signalsPageStore.getTaskLoading(
                        "LoadDashboards",
                    )}
                    dashboards={signalsPageStore.userDashboards.filter(
                        (dashboard) => !dashboard.isFavorite,
                    )}
                />
            </Grid>
            {!!signalsPageStore.sharedDashboards.length && (
                <>
                    <SectionHeader divider title="SHARED WITH ME" />
                    <Grid container sx={{ paddingX: 2 }}>
                        <SidebarDashboards
                            isLoading={signalsPageStore.getTaskLoading(
                                "LoadDashboards",
                            )}
                            dashboards={signalsPageStore.sharedDashboards.filter(
                                (dashboard) => !dashboard.isFavorite,
                            )}
                        />
                    </Grid>
                </>
            )}
        </>
    );
});

export default SignalsNavItems;

// Reusable section header component
const SectionHeader = ({
    title,
    divider,
}: {
    title: string;
    divider?: boolean;
}) => (
    <Grid
        container
        justifyContent={"space-between"}
        alignItems={"baseline"}
        sx={{ fontWeight: theme.typography.fontWeightBold }}
    >
        {divider && (
            <Grid
                item
                xs={12}
                style={{
                    paddingTop: theme.spacing(1),
                    paddingBottom: theme.spacing(1),
                }}
            >
                <Divider />
            </Grid>
        )}

        <Grid
            item
            style={{
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                paddingRight: theme.spacing(2),
                paddingLeft: theme.spacing(3),
                color: theme.palette.gray.main,
                fontSize: "12px",
            }}
        >
            {title}
        </Grid>
    </Grid>
);
